module.exports = __webpack_public_path__ + "img/special-img-3.ef50ab90.svg";